import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { environment } from '../../../../../../environments/environment';
import { StripePaymentService } from '../../../../shared/services/stripePayment.service';
import { LocalUserService } from '../../../../shared/services/localUser';
import { CaseService } from '../../../../shared/services/case.service';
import { PlaidService } from '../../../../shared/services/plaid.service';
import { UserService } from '../../../../shared/services/user.service';
import { OrganizationServices } from 'app/main/shared/services/organization.services';

declare let Plaid: any;
@Component({
  selector: 'app-mode-of-payments-dialog',
  templateUrl: './mode-of-payments-dialog.component.html',
  styleUrls: ['./mode-of-payments-dialog.component.scss'],
  providers: [
    PlaidService
  ]
})
export class ModeOfPaymentsDialogComponent implements OnInit {
  loading: boolean = false;
  selectMode: string;
  stripeHandler: any;
  transactionId: any;
  userId: any;
  plaidCustomerId: any;
  caseData: any;
  plaidHandler: any;
  stripeRef: any = (<any>window).Stripe(environment.stripePublishableKey); // publishable key is required
  elements: any = this.stripeRef.elements();
  paymentModes: any = [];
  formFee: any = 0;
  formActionLoading = false;
  finalFee: any;
  paymentMsg: any;
  totalFee: any;
  orgznId: any;
  constructor(
    private stripeService: StripePaymentService,
    public dialogRef: MatDialogRef<ModeOfPaymentsDialogComponent>,

    private caseService: CaseService,

    private localUser: LocalUserService,
    private plaidService: PlaidService,
    private userService: UserService,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private organizationServices: OrganizationServices
  ) {
    this.userId = this.localUser.getUserId();
    this.formFee = this.data.formFee;
    if(this.data.org == undefined) {
      if(this.data.temp != undefined) {
        this.caseService.getCaseById('', this.data.temp)
        .subscribe(result => {
          this.data.org = result.summary.organization_id;
        });
      }
    }
    if(this.data.temp != undefined) {
      this.caseService.getCaseById('', this.data.temp)
      .subscribe(result => {
        this.orgznId = result.summary.organization_id;
      });
    }
    else {
      this.orgznId = localStorage.getItem('tempOrg');
    }
    let dataTypes = ['INVENTORY', 'GENERATE_dOC']
    if (dataTypes.includes(this.data.type) ) {
      this.formFee = parseFloat('' + this.data.formFee + '') * 100; // Convert to cents
    }
  }
  ngOnInit() {
    console.log('In ngOnInit mode of payment: ', this.data);
    this.getCaseData();
    // Default to add credit card always then user preference set data
    this.paymentModes.push({
      paymentKey: 'CREDIT_CARD',
      paymentVal: this.userService.getUserPaymentPrefDisplayValue('CREDIT_CARD')
    });
    console.log('paymentModes: ', this.paymentModes);
    
    // To get user saved payment preference and populate in dropdown
    let userSaved = this.localUser.getUser();
    // Example payment preference json:-
    // payment_preference': {'plaidCustomerId':'cus_G1gDVup4ATjbVJ','paymentPreferred':'ACH_MICRO_DEPOSITS', 'status': 'NOT_VERIFIED' }
    if (userSaved && userSaved.paymentPref && userSaved.paymentPref.paymentPreferred === 'ACH_MICRO_DEPOSITS' && userSaved.paymentPref.status === 'VERIFIED') {
      let defaultPaymentTypeToSet = this.userService.getPaymentPrefValueToSet(
        userSaved.paymentPref.paymentPreferred.toString()
      );
      let defaultPaymentValueToSet = this.userService.getUserPaymentPrefDisplayValue(
        userSaved.paymentPref.paymentPreferred.toString()
      );
      if (defaultPaymentTypeToSet.indexOf('ACH') !== -1) {
        defaultPaymentValueToSet = 'ACH';
      }
      // TODO: verify status of users saved prefereces, if it is micro-deposits then ask user to verify by giving two amounts
      // To add user saved payment preferences
     if(defaultPaymentValueToSet != 'Credit Card'){
      this.paymentModes.push({
        paymentKey: '' + defaultPaymentTypeToSet + '',
        paymentVal: '' + defaultPaymentValueToSet + ''
      });
     }
      this.plaidCustomerId = userSaved.paymentPref.plaidCustomerId;
      this.selectMode = '' + defaultPaymentTypeToSet + '';
    }else if (userSaved && userSaved.paymentPref && userSaved.paymentPref.paymentPreferred === 'ACH_INSTANT_PAY') {
      this.paymentModes.push({
        paymentKey: 'ACH_INSTANT',
        paymentVal: 'ACH' // this.userService.getUserPaymentPrefDisplayValue('ACH_INSTANT_PAY')
      });
      this.selectMode = 'ACH_INSTANT';
    } else if (userSaved && userSaved.paymentPref && userSaved.paymentPref.paymentPreferred === 'PAY_IN_PERSON') {
      this.paymentModes.push({
        paymentKey: 'CHECK',
        paymentVal: 'Pay In Person'
      });
      this.selectMode = 'CHECK';
    }
    else {
      // to check for User's payment preference is set or not and show dialog
      // this.userService.checkIfUserPaymentPreferenceSet(userSaved);
      // Default to add ACH Instant with Credit card if user's payment preferences not set
      // this.paymentModes.push({
      //   paymentKey: 'ACH_INSTANT',
      //   paymentVal: 'ACH' // this.userService.getUserPaymentPrefDisplayValue('ACH_INSTANT_PAY')
      // });

      // let successMsg = 'ACH Micro deposits account is not verified. Please verify it from users settings';
      // this.snackBar.open(successMsg, null, {
      //   extraClasses: ['success-snackbar'],
      //   duration: 5000
      // });
      this.selectMode = 'CREDIT_CARD';
    }
    this.getChargesApplicable(this.selectMode, this.formFee);
  }

  getChargesApplicable(paymentVal, feeInCents) {
    var totalCents;
    switch(paymentVal) {
      case 'CHECK':
        // No charges
        totalCents = feeInCents;
        this.paymentMsg = '';
        break;
      case 'ACH_INSTANT':
        // 0.8% max $5
      case 'ACH_MICRO':
        // 0.8% max $5
        let charge = feeInCents * 0.008;
        totalCents = feeInCents + charge;
        this.paymentMsg = 'Charges applicable 0.8% for $' + (feeInCents/100);
        break;
      case 'CREDIT_CARD':
        // 2.9% + 30¢
        let charges = (feeInCents * 0.029) + 30;
        totalCents = feeInCents + charges;
        this.paymentMsg = 'Charges applicable 2.9% + 30¢ for $' + (feeInCents/100);
        break;
      default:
        totalCents = feeInCents;
        this.paymentMsg = '';
        break;
    }
    this.finalFee = (totalCents/100).toFixed(2);
    this.totalFee = Math.round(totalCents);
  }
  submitMode() {
    setTimeout(() => {
      let formData = null;
      let fee = this.totalFee;

      if (this.data.type === 'INVENTORY') {
        formData = {
          status: 'INVENTORY_AMOUNT_PAID'
        };
      }
      if (this.data.type === 'FILE_PETITION') {
        formData = {
          status: 'FILE_PETITION_AMOUNT_PAID'
        };
      }
      let localUserId = this.userId;
      let caseId = null;
      if (this.data.case.id) {
        caseId = this.data.case.id;
      } else if (this.caseData) {
        caseId = this.caseData.id;
      }
      let that = this;
      switch (this.selectMode) {
        case 'CHECK':
          this.formActionLoading = true;
          if (this.data.type === 'INVENTORY') {
            formData.status = 'INVENTORY_AMOUNT_CHECK_PAID';
          }
          if (this.data.type === 'FILE_PETITION') {
            formData.status = 'FILE_PETITION_AMOUNT_PAID';
          }
          this.stripeService
          .postStripePayment(this.orgznId, this.userId, '', fee, false)
          .subscribe(result => {
            txnId = result.id;
            if (that.data.type === 'INVENTORY') {
              if (txnId != null) {
                this.stripeService.updateStripePayment(txnId, caseId, {
                  "description":"Inventory Amount Paid"
                }).subscribe(stripeResult => {});
              }
              this.caseService
              .putCaseNew(this.data.org, this.data.case.id, formData)
              .subscribe(result => {
                this.formActionLoading = false;
                this.dialogRef.close(true);
              });
            }
            else if (that.data.type === 'FILE_PETITION') {
              that.dialogRef.close({value: 'true', txnId: txnId});
            }
            // that.dialogRef.close({value: 'true', txnId: txnId});
          });
          break;
        case 'ACH_INSTANT':
          this.formActionLoading = true;
          this.plaidHandler = Plaid.create({
            clientName: 'eGuard',
            env: 'sandbox',
            key: environment.plaidKey,
            apiVersion: 'v2',
            product: ['auth'],
            webhook: environment.plaidWebhook,
            selectAccount: true,
            onSuccess: (public_token, metadata) => {
              // Send the public_token and account ID to your app server.
              let postPlaidAchObj = {
                process_type: 'ACH_INSTANT_PAY',
                public_token: public_token,
                account_id: metadata.account_id,
                amount: fee, // value in cents
                case_id: caseId,
                user_id: localUserId,
                customer_id: null,
                microDepositAmounts: null
              };
              if(caseId == null) {
                postPlaidAchObj["organization_id"] = this.orgznId;
              }
              that.loading = true;
              this.formActionLoading = true;
              that.plaidService.postACHPlaid(postPlaidAchObj).subscribe(
                result => {
                  console.log(
                    'ACH_INSTANT_PAY got result',
                    JSON.stringify(result)
                  );
                  this.formActionLoading = false;
                  // TODO: Update case with proper status or transaction Id
                  if (result.id !== null) {
                    that.transactionId = result.id;
                    if (that.data.type === 'INVENTORY') {
                      this.caseService
                        .putCaseNew(this.data.org, this.data.case.id, formData)
                        .subscribe(caseUpdateResult => {
                          that.loading = false;
                          that.dialogRef.close(true);
                        });
                    } else{
                      that.dialogRef.close({value: 'true'});
                    }
                  }
                },
                Error => {
                  that.loading = false;
                  this.formActionLoading = false;
                  console.error('ACH_INSTANT_PAY got error');
                  console.error(Error);
                  this.snackBar.open(Error.response.data, null, {
                    extraClasses: ['error-snackbar'],
                    duration: 5000
                  });
                }
              );
            }
          });
          this.plaidHandler.open();
          break;
        case 'CREDIT_CARD':
          this.formActionLoading = true;
          var txnId;
          // Credit card
          this.stripeHandler = (<any>window).StripeCheckout.configure({
            key: environment.stripeKey,
            locale: 'auto',
            token: (token: any) => {
              this.stripeHandler.isTokenGenerate = true;
              this.stripeService
                .postStripePayment(this.orgznId, this.userId, token, fee, true)
                .subscribe(result => {
                  that.transactionId = result.id;
                  txnId = result.id;
                  if (that.data.type === 'INVENTORY') {
                    if (this.transactionId != null) {
                      this.stripeService.updateStripePayment(this.transactionId, caseId, {
                        "description":"Inventory Amount Paid"
                      }).subscribe(stripeResult => {});
                    }
                    this.caseService
                      .putCaseNew(this.data.org, this.data.case.id, formData)
                      .subscribe(caseUpdateResult => {
                        that.dialogRef.close(true);
                    });
                  }
                  this.formActionLoading = false;
                });
            }
          });

          let stripeCCName = null;
          if (this.data.type === 'INVENTORY') {
            stripeCCName = 'Inventory Fees';
          }
          if (this.data.type === 'FILE_PETITION') {
            formData.status = 'Court Fee';
          }
         
            this.stripeHandler.open({
              name: stripeCCName,
              description: 'Submission Fee',
              amount: fee,
              image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
              zipCode: true,
              closed: () => {
                if (!this.stripeHandler.isTokenGenerate) {
                  this.formActionLoading = false;
                  console.log('Stripe dialog was closed');
                  that.dialogRef.close({value: 'false'});
                }
                else {
                  console.log('Amount paid by credit card');
                    setTimeout(() => {
                        if(txnId) {
                          this.formActionLoading = false;
                          that.dialogRef.close({value: 'true', txnId: txnId});
                        }
                        else {
                          this.formActionLoading = false;
                          that.dialogRef.close({value: 'true'});
                        }
                    }, 12000);
                }
              }
            });
          break;
        case 'ACH_MICRO':
          this.formActionLoading = true;
          // Send the customer Id saved in micro-depsoit ach account
          let microPayObj = {
            process_type: 'ACH_MICRO_DEPOSIT_PAY',
            public_token: null,
            account_id: null,
            amount: fee, // value in cents
            case_id: caseId,
            user_id: localUserId,
            customer_id: this.plaidCustomerId,
            microDepositAmounts: null
          };
          if(caseId == null) {
            microPayObj["organization_id"] = this.orgznId;
          }
          this.loading = true;
          this.plaidService.postACHPlaid(microPayObj).subscribe(
            resultACH => {
              that.loading = false;
              let txnId = resultACH.id;
              this.formActionLoading = false;
              console.log(
                'ACH_MICRO_DEPOSIT_PAY got result',
                JSON.stringify(resultACH)
              );
              // TODO: Update case with proper status or transaction Id
              if (that.data.type === 'INVENTORY') {
                this.caseService
                  .putCaseNew(this.data.org, this.data.case.id, formData)
                  .subscribe(caseUpdateResult => {
                    that.loading = false;
                    that.dialogRef.close(true);
                  });
              }else{
                that.dialogRef.close({value: 'true', txnId: txnId});
              }
            },
            Error => {
              this.loading = false;
              this.formActionLoading = false;

              console.error('ACH_MICRO_DEPOSIT_PAY got error');
              console.error(JSON.stringify(Error));
              this.snackBar.open(Error.response.data, null, {
                extraClasses: ['error-snackbar'],
                duration: 5000
              });
            }
          );
          break;
        default:
          console.error('Not handled mode');
          break;
      }
    }, 2000);
  }
  getCaseData() {
    if (this.data.org && this.data.case.id) {
      this.caseService
        .getCaseById(this.data.org, this.data.case.id)
        .subscribe(result => {
          this.caseData = result;
        });
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/dailog/mode-of-payments-dialog/mode-of-payments-dialog.component.ts